/**
 * HQ 오류 게시판 API 클라이언트.
 * 백엔드: /api/v1/hq/error-reports/*
 */
import hqApi from './hqApiClient';

export interface HqErrorReportListItem {
  id: string;
  organization_id: string;
  store_name: string;
  reporter_name?: string;
  title: string;
  category?: string;
  status: string;
  claude_verdict?: string;
  created_at: string;
  attachment_count: number;
}

export interface HqAttachment {
  id: string;
  filename?: string;
  mime?: string;
  size?: number;
}

export interface HqErrorReportDetail {
  id: string;
  organization_id: string;
  store_name: string;
  reporter_name?: string;
  reporter_role?: string;
  title: string;
  content: string;
  category?: string;
  page_url?: string;
  app_context?: Record<string, any> | null;
  status: string;
  claude_verdict?: string | null;
  claude_analysis?: string | null;
  claude_checked_at?: string | null;
  hq_memo?: string | null;
  admin_reply?: string | null;
  created_at: string;
  updated_at?: string;
  resolved_at?: string | null;
  attachments: HqAttachment[];
}

const BASE = '/api/v1/hq/error-reports';

export const hqErrorReportService = {
  async list(params: { status?: string; organization_id?: string; q?: string } = {}): Promise<HqErrorReportListItem[]> {
    const { data } = await hqApi.get(BASE, { params });
    return (data?.reports || []) as HqErrorReportListItem[];
  },
  async summary(): Promise<{ open_count: number; unresolved_count: number }> {
    const { data } = await hqApi.get(`${BASE}/summary`);
    return { open_count: data?.open_count || 0, unresolved_count: data?.unresolved_count || 0 };
  },
  async detail(id: string): Promise<HqErrorReportDetail> {
    const { data } = await hqApi.get(`${BASE}/${id}`);
    return data?.report as HqErrorReportDetail;
  },
  async update(id: string, body: { status?: string; hq_memo?: string; admin_reply?: string }) {
    const { data } = await hqApi.put(`${BASE}/${id}`, body);
    return data;
  },
  /** 인증이 필요한 첨부 이미지를 blob 으로 받아 object URL 반환 */
  async attachmentObjectUrl(id: string, attId: string): Promise<string> {
    const res = await hqApi.get(`${BASE}/${id}/attachments/${attId}`, { responseType: 'blob' });
    return URL.createObjectURL(res.data);
  },
};
